module.exports = __webpack_public_path__ + "img/chart-scatter-3d.a9557b86.svg";